<div class="itens-scroll">
  <table class="itens-table">
    <thead><tr><th>Produto</th><th>Grupo</th><th class="numero">Qtde.</th><th class="numero">Unitário (R$)</th><th class="numero">Subtotal</th>
      @if (podeExibirMargemItemPedido) { <th class="numero">Margem</th> }
      @if (exibirPontuacao) { <th class="numero">Pontuação</th> }
      @if (!pedidoAprovarExterno) { <th class="numero">Ações</th> }
    </tr></thead>
    <tbody>
      @for (produtoAdicionado of produtosAdicionados; track produtoAdicionado; let i = $index) {
        <tr class="item-principal">
          <td><div class="produto-identificacao">
            <button type="button" class="item-icone item-expandir" (click)="alternarDetalhes(produtoAdicionado)" [attr.aria-expanded]="itensExpandidos.has(produtoAdicionado)" [attr.aria-label]="(itensExpandidos.has(produtoAdicionado) ? 'Recolher ' : 'Expandir ') + produtoAdicionado.name">
              <i class="fa" [ngClass]="itensExpandidos.has(produtoAdicionado) ? 'fa-chevron-down' : 'fa-chevron-right'" aria-hidden="true"></i>
            </button>
            <div><small>{{ produtoAdicionado.codigo }}</small><strong>{{ produtoAdicionado.name }}</strong>
            @if (produtoAdicionado.qtde_bonificada > 0) { <span class="badge badge-success">+{{ produtoAdicionado.qtde_bonificada }} BONIFICADA(S)</span> }
            @if (produtoAdicionado.erro_valor) { <span class="erro">Valor inválido</span> }
            </div></div>
          </td>
          <td>{{ produtoAdicionado.grupo_estoque }}</td>
          <td class="numero">{{ produtoAdicionado.qtde ?? '—' }}</td>
          <td class="numero">{{ formatarValoresQuatroCasasDecimais(produtoAdicionado.valor) }}</td>
          <td class="numero"><b>{{ produtoAdicionado.valor_imposto_total_final | currency: 'BRL' }}</b></td>
          @if (podeExibirMargemItemPedido) { <td class="numero">{{ calcularMargemItemPedido(produtoAdicionado) | number: '1.2-2' }}%</td> }
          @if (exibirPontuacao) { <td class="numero">{{ produtoAdicionado.pontuacao_calculada | number: '1.2-2' }}</td> }
          @if (!pedidoAprovarExterno) {
            <td class="numero item-acoes">
              <button type="button" class="item-icone item-editar" title="Editar item" [attr.aria-label]="'Editar ' + produtoAdicionado.name" [disabled]="calculando" (click)="itemEditado.emit({ id_produto: produtoAdicionado.id, id_campanha: produtoAdicionado.id_campanha })"><i class="fa fa-pencil" aria-hidden="true"></i></button>
              <button type="button" class="item-icone item-excluir" title="Excluir item" [attr.aria-label]="'Excluir ' + produtoAdicionado.name" [disabled]="calculando" (click)="itemExcluido.emit({ indice: i, id_produto: produtoAdicionado.id, id_campanha: produtoAdicionado.id_campanha })"><i class="fa fa-trash-o" aria-hidden="true"></i></button>
            </td>
          }
        </tr>
        @if (itensExpandidos.has(produtoAdicionado)) {
        <tr><td class="detalhes-cell" [attr.colspan]="totalColunas">
          <div class="item-detalhes">
            <dl class="detalhes-grid">
              @if (fatorFinanceiroAtivo) {
                <div><dt>Fator (%)</dt><dd>{{ produtoAdicionado.porcentagem_fator_inicial == null ? '—' : (produtoAdicionado.porcentagem_fator_inicial | number: '1.2-2') }}</dd></div>
                <div><dt>Fator (R$)</dt><dd>{{ valorFatorItem(produtoAdicionado) == null ? '—' : formatarValoresQuatroCasasDecimais(valorFatorItem(produtoAdicionado)) }}</dd></div>
              }
              <div><dt>Desconto (%)</dt><dd>{{ produtoAdicionado.porcentagem_desconto_temporaria != null ? formatarValoresQuatroCasasDecimais(produtoAdicionado.porcentagem_desconto_temporaria, true) : (produtoAdicionado.porcentagem_desconto | number: '1.2-2') }}</dd></div>
              <div><dt>{{ fatorFinanceiroAtivo ? 'Tabela sem fator' : 'Tabela' }}</dt><dd>{{ (fatorFinanceiroAtivo ? valorSemFatorItem(produtoAdicionado) : produtoAdicionado.valor) | currency: 'BRL' }}</dd></div>
              @if (fatorFinanceiroAtivo) { <div><dt>Tabela com fator</dt><dd>{{ produtoAdicionado.valor | currency: 'BRL' }}</dd></div> }
              @if (configuracao?.flag_exibir_imposto_produto) { <div><dt>Imposto (R$)</dt><dd>{{ formatarValoresQuatroCasasDecimais(produtoAdicionado.valor_imposto_unitario) }}</dd></div> }
            </dl>
            @if (configuracao?.flag_exibe_observacao_item_pedido && produtoAdicionado.observacao_item) { <p>{{ produtoAdicionado.observacao_item }}</p> }
            @if (produtoAdicionado.descritivo_desconto) { <p>{{ produtoAdicionado.descritivo_desconto }}</p> }
          </div>
        </td></tr>
        }
                @if (produtoAdicionado.produtos_vinculados != null) {
                  <tr>
                    <td class="p-3" [attr.colspan]="totalColunas">
                      <table class="table table-sm table-hover">
                        <thead>
                          <tr>
                            <th class="text-center">Código</th>
                            <th class="tabela_borda">Descrição</th>
                            <th class="text-center tabela_borda">Qtde</th>
                            <th class="text-right tabela_borda">Unitário: R$</th>
                            @if (exibirFatorFinanceiro) {
                              <th class="text-right tabela_borda">Fator: R$</th>
                            }
                            @if (exibirFatorFinanceiro) {
                              <th class="text-right tabela_borda bg_tabela_danger">C/ Fator: R$</th>
                            }
                            @if (exibirPontuacao) {
                              <th class="text-right tabela_borda bg_tabela_warning">Pontuação</th>
                            }
                            @if (configuracao != null && configuracao.flag_exibir_imposto_produto) {
                              <th class="text-right tabela_borda">Imposto: R$</th>
                            }
                            <th class="text-right tabela_borda">Sub-Total: R$</th>
                          </tr>
                        </thead>
                        <tbody>
                          @for (produto_vinculado of produtoAdicionado.produtos_vinculados; track produto_vinculado) {
                            @if (produto_vinculado.qtde > 0 && (!produto_vinculado.bonificacao || (produto_vinculado.bonificacao && produto_vinculado.bonificacao_selecionada))) {
                              <tr>
                                <td class="text-center" data-label="Código">{{ produto_vinculado.codigo }}</td>
                                <td class="tabela_borda" data-label="Descrição">
                                  {{ produto_vinculado.name }}
                                  @if (produtoAdicionado.preco_bonificacao == 'B' && produtoAdicionado.bonificacao_selecionavel && produto_vinculado.bonificacao_selecionada) {
                                    <span class="badge badge-success produto_campanha_bonificado"><b> BONIFICAÇÃO</b></span>
                                  }
                                  @if (produtoAdicionado.preco_bonificacao == 'B' && !produtoAdicionado.bonificacao_selecionavel && produto_vinculado.bonificacao_selecionada) {
                                    <span class="badge badge-success produto_campanha_bonificado">
                                      @if (!produtoAdicionado.bonificacao_multiplicavel) {
                                        +{{ produtoAdicionado.qtde_bonificacao_multiplicavel }} UNIDADE GRÁTIS
                                      }
                                      @if (produtoAdicionado.bonificacao_multiplicavel) {
                                        +{{ produtoAdicionado.qtde_bonificacao_multiplicavel }} {{ produtoAdicionado.qtde_bonificacao_multiplicavel > 1 ? 'UNIDADES' : 'UNIDADE' }} GRÁTIS
                                      }
                                    </span>
                                  }
                                </td>
                                <td class="text-center tabela_borda" data-label="Qtde">{{ produto_vinculado.qtde }}</td>
                                <td class="text-right tabela_borda" data-label="Unitário: R$">
                                  @if (!produto_vinculado.bonificacao) {
                                    <span>{{ produto_vinculado.price_promotional | currency: 'BRL' }}</span>
                                  }
                                  @if (produto_vinculado.bonificacao) {
                                    <span>-</span>
                                  }
                                </td>
                                @if (exibirFatorFinanceiro) {
                                  <td class="text-right tabela_borda" data-label="Fator: R$">
                                    @if (!produto_vinculado.bonificacao) {
                                      <span><b>{{ formatarValoresQuatroCasasDecimais(produto_vinculado.valor_fator_financeiro_unitario) }}</b></span>
                                    }
                                    @if (produto_vinculado.bonificacao) {
                                      <span>-</span>
                                    }
                                  </td>
                                }
                                @if (exibirFatorFinanceiro) {
                                  <td class="text-right tabela_borda bg_tabela_danger" data-label="C/ Fator: R$">
                                    @if (!produto_vinculado.bonificacao) {
                                      <span><b>{{ produto_vinculado.valor_fator_financeiro_produto | currency: 'BRL' }}</b></span>
                                    }
                                    @if (produto_vinculado.bonificacao) {
                                      <span>-</span>
                                    }
                                  </td>
                                }
                                @if (exibirPontuacao) {
                                  <td class="text-right tabela_borda bg_tabela_warning" data-label="Pontuação">
                                    @if (!produto_vinculado.bonificacao) {
                                      <span><b>{{ produto_vinculado.pontuacao_calculada | number: '1.2-2' }}</b></span>
                                    }
                                    @if (produto_vinculado.bonificacao) {
                                      <span>-</span>
                                    }
                                  </td>
                                }
                                @if (configuracao != null && configuracao.flag_exibir_imposto_produto) {
                                  <td class="text-right tabela_borda" data-label="Imposto: R$">
                                    @if (!produto_vinculado.bonificacao) {
                                      <span><b>{{ formatarValoresQuatroCasasDecimais(produto_vinculado.valor_imposto_unitario) }}</b></span>
                                    }
                                    @if (produto_vinculado.bonificacao) {
                                      <span>-</span>
                                    }
                                  </td>
                                }
                                <td class="text-right tabela_borda" data-label="Sub-Total: R$">
                                  @if (!produto_vinculado.bonificacao) {
                                    <span><b>{{ produto_vinculado.valor_imposto_total | currency: 'BRL' }}</b></span>
                                  }
                                  @if (produto_vinculado.bonificacao) {
                                    <span>-</span>
                                  }
                                </td>
                              </tr>
                            }
                          }
                        </tbody>
                      </table>
                    </td>
                  </tr>
                }

      } @empty {
        <tr><td class="itens-vazio" [attr.colspan]="totalColunas">Nenhum item adicionado. Use “Adicionar item” para selecionar os produtos.</td></tr>
      }
    </tbody>
  </table>
</div>
<table class="table table-sm">  @if (pedidoItensInativos.length > 0) {
    <tr>
      <td class="text-center">
        <b>Bonificação Vinculada</b>
      </td>
    </tr>
  }
  @if (pedidoItensInativos.length > 0) {
    <tr>
      <td>
        <div class="table-responsive">
          <cdk-virtual-scroll-viewport class="tabela_sm" [itemSize]="20">
            <table class="table table-sm">
              <thead>
                <tr>
                  <th class="text-center">#</th>
                  <th class="text-center tabela_borda">Código</th>
                  <th class="tabela_borda">Descrição</th>
                  <th class="text-center tabela_borda">Qtde</th>
                  <th class="text-right tabela_borda">Unitário: R$</th>
                  <th class="text-right tabela_borda">Total: R$</th>
                </tr>
              </thead>
              <tbody>
                <ng-container *cdkVirtualFor="let pedidoItemInativo of pedidoItensInativos; let i = index; templateCacheSize: 0;">
                  <tr>
                    <td class="text-center" data-label="#">{{ i + 1 }}</td>
                    <td class="text-center tabela_borda" data-label="Código">{{ pedidoItemInativo.produto_codigo }}</td>
                    <td class="tabela_borda" data-label="Descrição">{{ pedidoItemInativo.produto_nome }}</td>
                    <td class="text-center tabela_borda" data-label="Qtde">{{ pedidoItemInativo.quantity }}</td>
                    <td class="text-right tabela_borda" data-label="Unitário: R$">{{ pedidoItemInativo.unit_price | currency: 'BRL' }}</td>
                    <td class="text-right tabela_borda" data-label="Total: R$">{{ pedidoItemInativo.total | currency: 'BRL' }}</td>
                  </tr>
                </ng-container>
              </tbody>
            </table>
          </cdk-virtual-scroll-viewport>
        </div>
      </td>
    </tr>
  }
</table>
